import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

const PromotionDialog = ({
  loading,
  selected,
  open,
  onClose,
  promoteEquipment,
  pointsByEquipId,
}) => {
  if (!selected || selected.length <= 0) return null;

  const handlePromote = () => {
    promoteEquipment(selected)
      .then((result) => {
        const closeResult = {
          status: 'success',
          equipment: selected.reduce((accumulator, currentValue) => {
            accumulator[currentValue] = {
              status: 'ok',
              points: pointsByEquipId[currentValue].reduce((pointsAccumulator, equipmentPoint) => {
                // We're formulating a point status object in this control block
                // If the point exists in our result with more than 0 errors, then it failed to promote
                // Otherwise, it succeeded.
                if (
                  equipmentPoint.topic in result.points &&
                  result.points[equipmentPoint.topic].length > 0
                ) {
                  // The point failed
                  // eslint-disable-next-line
                  pointsAccumulator[equipmentPoint.topic] = {
                    status: 'error',
                    message: `${equipmentPoint.topic} failed validation because of an invalid ${
                      result.points[equipmentPoint.topic]
                    }`,
                  };
                  return pointsAccumulator;
                }
                // Success
                // eslint-disable-next-line
                pointsAccumulator[equipmentPoint.topic] = {
                  status: 'ok',
                };
                return pointsAccumulator;
              }, {}),
            };
            if (
              Object.values(accumulator[currentValue].points).some(
                (point) => point.status === 'error'
              )
            ) {
              accumulator[currentValue].status = Object.values(
                accumulator[currentValue].points
              ).some((point) => point.status === 'ok')
                ? 'partial'
                : 'error';
            }
            return accumulator;
          }, {}),
        };
        if (selected.every((equipKey) => closeResult.equipment[equipKey].status === 'error'))
          closeResult.status = 'failure';
        else if (selected.some((equipKey) => closeResult.equipment[equipKey].status === 'partial'))
          closeResult.status = 'partial';
        onClose(closeResult);
      })
      .catch((e) => {
        onClose({
          errors: { e },
        });
      });
  };

  const countPoints = (equipToCount) =>
    Object.entries(pointsByEquipId)
      .map((entry) => (equipToCount.includes(entry[0]) ? entry[1].length : 0))
      .reduce((sum, inc) => sum + inc, 0);

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Promotion</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" component="label" htmlFor="myField">
          {selected.length} equipment / {countPoints(selected)} points will be promoted
        </Typography>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between' }}>
        <Button
          variant="contained"
          onClick={() => onClose(undefined)}
          color="error"
          disabled={loading}
        >
          Abort
        </Button>
        <Button variant="contained" onClick={handlePromote} color="success" disabled={loading}>
          Promote
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PromotionDialog;
